import { takeLatest } from 'redux-saga/effects';
import { getPaginatedListSaga } from '../../../store/structures';
import { types, actions } from './duck';
import { getCategorizedList, getBrowseList } from '../../coupons/api';
import { markAsFavouriteSaga, removeFavouriteSaga } from '../favourite/saga';

export default function* saga() {
  yield takeLatest(
    types.GET_ALL_LIST,
    getPaginatedListSaga(actions, getCategorizedList),
  );
  yield takeLatest(
  types.GET_BROWSE_LIST,
  getPaginatedListSaga(actions, getBrowseList),
);
  yield takeLatest(types.MARK_AS_FAVOURITE, markAsFavouriteSaga);
  yield takeLatest(types.REMOVE_FAVOURITE, removeFavouriteSaga);
}
